import {DatePicker} from 'antd';
import moment from 'moment';
import React from 'react';
import {FormyComponent} from '../../../src/Formy/FormyComponent';
import {FormyTextBaseProps} from '../../../src/Formy/FormyTextBase';
import {I18nSimpleKey} from '../../../src/i18n/i18n';
import {getDateFormat} from '../../../src/util/date-util';
import {Apis} from '../apis/Apis';
import {ApisContext} from '../apis/ApisContext';
import {Label} from './FormyLabel';

export interface FormyDatePickerProps<F, Fk extends keyof F> extends FormyTextBaseProps<F, Fk> {
  placeholder?: I18nSimpleKey;
}

export class FormyDatePicker<F extends {[P in Fk]: null | string}, Fk extends keyof F> extends FormyComponent<
  F,
  Fk,
  FormyDatePickerProps<F, Fk>
> {
  static contextType = ApisContext;
  context!: Apis;

  render() {
    return (
      <>
        {this.props.label && <Label>{this.props.formy.t(this.props.label)}:</Label>}
        <DatePicker
          data-testid={`FormyDatePicker-${String(this.props.field)}`}
          placeholder={this.props.placeholder && this.props.formy.t(this.props.placeholder)}
          value={this.value ? moment(this.value) : null}
          format={getDateFormat(this.context.locale)}
          className={'formy-item-style'}
          disabled={this.mode === 'view'}
          // Be careful not to use toISOString().slice(0, 10), because we want the user selected date and not the UTC
          // date (e.g. if UTC+2 user at 00:30 selected 1.1., then toISOString().slice(0, 10) would return 31.12., which
          // is not what the user wanted.
          onChange={date => this.handleChange((date ? moment(date).format('YYYY-MM-DD') : null) as F[Fk])}
        />
      </>
    );
  }
}
